<template>
  <v-app>
    <v-app-bar clipped-left app dark dense color="bluePcm">
      <v-spacer />
      <ClientNameAppbar class="barra-topo" />

      <v-btn icon color="orangePcm" @click="refreshInfo">
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
      <v-btn icon color="orangePcm" @click="logoff">
        <v-icon>mdi-power-standby</v-icon>
      </v-btn>
    </v-app-bar>

    <v-main>
      <MainScreenOperator
        class="barra-superior"
        :clickToCallNewNumberRequest="clickToCallNewNumberRequest"
      />
      <!-- <div style="display: flex;">
        <HistoricoDoOperador
          v-on:clickToCallFromHistory="newCallNumber($event)"
          style="border-right: 1px solid #DCDCDC;"
        />
        <div class="alturaMonitor">
          <MonitorDoOperador />
        </div>
      </div> -->
    </v-main>
    <Footer />
  </v-app>
</template>

<script>
import { ioInstance } from "@/main";
import ClientNameAppbar from "@/componentes/ClientNameAppbar";
import Footer from "@/componentes/Footer";

import registerUserService from "@/utils/commomServices/registerUserService";

import MainScreenOperator from "../components/MainScreenOperator";
// import MonitorDoOperador from "../components/MonitorDoOperador";
// import HistoricoDoOperador from "../components/HistoricoDoOperador";

export default {
  name: "OperadorSceen",
  components: {
    MainScreenOperator,
    // MonitorDoOperador,
    // HistoricoDoOperador,
    ClientNameAppbar,
    Footer,
  },
  data: () => ({
    clickToCallNewNumberRequest: "",
  }),
  methods: {
    async logoff() {
      console.log("clicou");
      await registerUserService.loginOperador({
        action: "logout",
        realizouEvento: "Operador",
        agente: localStorage.getItem("operador_logado"),
      });

      localStorage.removeItem("pcm_access_token_operador");
      localStorage.removeItem("operador_logado");
      this.$router.go({
        name: "login",
      });
    },

    newCallNumber(number) {
      this.clickToCallNewNumberRequest = number;
    },

    refreshInfo() {
      ioInstance.emit("refreshInfo");
    },
  },
};
</script>

<style scoped>
.v-main {
  background-color: #fbfbfb;
}

/* .barra-topo {
 z-index: 4;
} */

/* .parent {
    display: grid;
    grid-template-columns: 1fr 2.5fr;
    grid-template-rows: 1fr;
    grid-column-gap: 0px;
    grid-row-gap: 0px;
  } */

/* .div1 {
    grid-area: 1 / 1 / 2 / 2;
  } */

/* .div2 {
    grid-area: 1 / 2 / 2 / 3;
  } */

.barra-superior {
  z-index: 4;
}

.historico {
  z-index: 2;
}

.alturaMonitor {
  overflow-x: hidden;
  height: calc(100vh - 100px);
  /* overflow-y: auto; */
}
</style>
